import { z } from 'zod';

export const getAddAgentSchema = (t: (key: string) => string) =>
  z
    .object({
      name: z.string().trim().min(1, t('AGENT_NAME_REQUIRED')).trim(),
      description: z.string().trim().min(1, t('AGENT_DESCRIPTION_REQUIRED')).trim(),
      create_from: z
        .enum([
          'customer_service_agent',
          'lead_generation_agent',
          'enterprise_search_agent',
          'general_agent',
          'it_support_agent',
          'hr_assistant_agent',
          'finance_assistant_agent',
          'healthcare_assistant_agent',
          'legal_info_agent',
          'education_assistant_agent',
        ])
        .optional(),
      agent_type: z.boolean().default(false),
    })
    .refine(
      (data) => {
        if (!data.create_from && !data.name) {
          return false;
        }
        return true;
      },
      {
        message: t('AGENT_NAME_REQUIRED_FOR_CUSTOM'),
        path: ['name'],
      }
    );

export type AddAgentFormValues = z.infer<ReturnType<typeof getAddAgentSchema>>;

export const addAgentDefaultValues = {
  name: '',
  description: '',
  create_from: undefined,
  agent_type: false,
};

export const PREDEFINED_PROMPTS = [
  {
    label: 'PREDEFINED_LABEL_CUSTOMER_SERVICE',
    value: 'customer_service_agent',
    description: 'PREDEFINED_DESCRIPTION_CUSTOMER_SERVICE',
  },
  {
    label: 'PREDEFINED_LABEL_LEAD_GENERATION',
    value: 'lead_generation_agent',
    description: 'PREDEFINED_DESCRIPTION_LEAD_GENERATION',
  },
  {
    label: 'PREDEFINED_LABEL_ENTERPRISE_SEARCH',
    value: 'enterprise_search_agent',
    description: 'PREDEFINED_DESCRIPTION_ENTERPRISE_SEARCH',
  },
  {
    label: 'PREDEFINED_LABEL_GENERAL_ASSISTANT',
    value: 'general_agent',
    description: 'PREDEFINED_DESCRIPTION_GENERAL_ASSISTANT',
  },
  {
    label: 'PREDEFINED_LABEL_IT_SUPPORT',
    value: 'it_support_agent',
    description: 'PREDEFINED_DESCRIPTION_IT_SUPPORT',
  },
  {
    label: 'PREDEFINED_LABEL_HR_ASSISTANT',
    value: 'hr_assistant_agent',
    description: 'PREDEFINED_DESCRIPTION_HR_ASSISTANT',
  },
  {
    label: 'PREDEFINED_LABEL_FINANCE_ASSISTANT',
    value: 'finance_assistant_agent',
    description: 'PREDEFINED_DESCRIPTION_FINANCE_ASSISTANT',
  },
  {
    label: 'PREDEFINED_LABEL_HEALTHCARE_ASSISTANT',
    value: 'healthcare_assistant_agent',
    description: 'PREDEFINED_DESCRIPTION_HEALTHCARE_ASSISTANT',
  },
  {
    label: 'PREDEFINED_LABEL_LEGAL_INFO',
    value: 'legal_info_agent',
    description: 'PREDEFINED_DESCRIPTION_LEGAL_INFO',
  },
  {
    label: 'PREDEFINED_LABEL_EDUCATION_ASSISTANT',
    value: 'education_assistant_agent',
    description: 'PREDEFINED_DESCRIPTION_EDUCATION_ASSISTANT',
  },
] as const;

export const AGENT_TYPE_FALSE_NAME = 'AGENT_TYPE_SEQUENTIAL_NAME';
export const AGENT_TYPE_FALSE_DESCRIPTION = 'AGENT_TYPE_SEQUENTIAL_DESCRIPTION';
export const AGENT_TYPE_TRUE_NAME = 'AGENT_TYPE_REASONING_NAME';
export const AGENT_TYPE_TRUE_DESCRIPTION = 'AGENT_TYPE_REASONING_DESCRIPTION';

